const asyncImport = require('util/asyncImport').default;
const {
	default: { breakMediumBefore },
} = require('util/sass-variables');
const {
	getNumber,
	trackGtm,
	fillWithDomElementsAll,
	fillWithDomElements,
} = require('util/functions');
const { mediaQueryMin } = require('util/functions');
const { stuttering, default: onWidthResize } = require('util/onWidthResize');
const {
	default: { mediumDelay },
} = require('util/sass-variables');
const mediumDelayMs = getNumber(mediumDelay) * 1000;
const CLASS_KEY_CONTROLS = '.key-figure--controls';
const CLASS_TNS_NAV = '.tns-nav';
const CLASS_PREV = '.key-figure--previous';
const CLASS_NO_SLIDER = 'no-slider';

const CLASS_KEY_FIGURES = 'key-figure--icon';
const CLASS_ELEMENT = 'key-figure--element';

const selectorAll = {
	elements: CLASS_ELEMENT,
};
const selector = {
	keyFigure: CLASS_KEY_FIGURES,
};
module.exports = {
	async init() {
		this.desktop = mediaQueryMin(breakMediumBefore);
		await asyncImport(this, ['TinySlider', 'debounce']);
		fillWithDomElementsAll(this, selectorAll);
		fillWithDomElements(this, selector);
		this.elements.forEach(element => {
			if (element.querySelector('a')) {
				element.addEventListener(
					'click',
					this.gtmTracking.bind(
						this,
						element.querySelector('a')?.href,
						element.dataset.index,
					),
				);
			}
		});

		if (
			(mediaQueryMin(breakMediumBefore) && this.elements.length > 5) ||
			!mediaQueryMin(breakMediumBefore)
		) {
			this.root.classList.remove(CLASS_NO_SLIDER);
			this.initTinySlider(this.keyFigure);
			this.moveNav();
		} else {
			this.root.classList.add(CLASS_NO_SLIDER);
		}
		onWidthResize(this.onResize.bind(this), stuttering.DEBOUNCE, 250);
	},
	async initTinySlider(element) {
		let loop = this.desktop ? false : true;
		let edgePadding = this.desktop ? 0 : 60;
		let items = this.desktop ? 5 : 1;

		this.slider = await this.TinySlider.tns({
			container: element,
			items: items,
			speed: mediumDelayMs,
			slideBy: 'page',
			loop: loop,
			gutter: 20,
			mouseDrag: false,
			edgePadding: edgePadding,
			navPosition: 'bottom',
			controlsContainer: this.root.querySelector(CLASS_KEY_CONTROLS),
			preventScrollOnTouch: 'auto',
		});
	},
	onResize() {
		if (
			(mediaQueryMin(breakMediumBefore) && this.elements.length > 5) ||
			!mediaQueryMin(breakMediumBefore)
		) {
			setTimeout(() => {
				if (this.slider !== undefined && this.slider?.destroy !== null) {
					this.slider.destroy();
				}
				this.root.classList.remove(CLASS_NO_SLIDER);
				//We have to reselect the key figures because TinySlider replaces the elements from DOM in the destory method
				let keyFigures = this.root.querySelector(`.${CLASS_KEY_FIGURES}`);
				this.desktop = mediaQueryMin(breakMediumBefore);
				this.initTinySlider(keyFigures);
				this.moveNav();
			}, 0);
		} else {
			setTimeout(() => {
				this.root.classList.add(CLASS_NO_SLIDER);
				if (this.slider !== undefined && this.slider?.destroy !== null) {
					this.slider.destroy();
				}
			}, 0);
		}
	},
	moveNav() {
		this.root
			.querySelector(CLASS_PREV)
			.after(this.root.querySelector(CLASS_TNS_NAV));
	},
	gtmTracking(href, index, e) {
		trackGtm({
			eventCategory: 'cta',
			eventAction: 'key figures',
			eventLabel: `${parseInt(index) + 1} | ${href}`,
		});
	},
};
